import { createEventGroup, eventProps } from '@app/shared/events/event.model';

export const AuthEvents = createEventGroup({
    feature: 'auth',
    events: {
        login: eventProps<{ platform: string }>(),
    },
});

